module.exports = __webpack_public_path__ + "static/media/teaser2-radeberger-x2.037ed2e4.jpg";